<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card class="px-5 py-3">
          <template v-slot:heading>
            <div class="headline mt-3 font-weight-light">
              {{ $t('ativacao') }}
            </div>
          </template>
          <v-form>
            <v-container class="py-0">             
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="senha"
                  :error="senhaErro"
                  class="purple-input"
                  label="Senha:"
                />
              </v-col>
             
              <v-col
                class="text-right"
                cols="12"
              >
                <v-btn
                  class="mx-0 font-weight-light"
                  color="success"
                  @click="doAtivar"
                >
                  Ativar
                </v-btn>
              </v-col>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      senha: '',
      senhaErro: false,
 //     errors: [],
    }),

    methods: {
      doAtivar () {
        if (!this.doValidate()) {
          return
        }        
        if (localStorage.chaveFuncionarioMobile && this.senha) {
          var funcionarioMobile = {
            'chave': localStorage.chaveFuncionarioMobile,
            'senha': this.senha
          }
          this.$http.post('/ProjetoX/rest/externo/funcionario/mobile/validar', funcionarioMobile).then(response => {
            localStorage.senhaFuncionarioMobile = this.senha            
            alert('Bem vindo ao W3G Profissional!')
            this.$router.push({ path: '/' })
          }).catch(error => {
            alert('Senha invalida.')
          })
        }
      },
      doValidate () {
    //    this.erros = []
        if (this.senha) {
          return true
        }
        if (!this.senha) {
     //     this.erros.push('A Senha é obrigatória.')
          this.senhaErro = true
        } else { this.senhaErro = false }
      },
    }
  }
</script>
